'use client';

import type { LinkNode } from 'data-layer';
import { CART_DIALOG_TYPE } from '../../../constants';
import { useCartErrorStore } from 'stores/cart';
import { CartDialogAlertGeneral } from './CartDialogAlertGeneral';
import { CartDialogAlertShippingAddress } from './CartDialogAlertShippingAddress';

interface CartAlertDialogsProps {
  constants?: Record<string, string>;
  links?: LinkNode[];
}

/**
 * CartErrorDialogs - Client Component for PayPal Express error dialogs.
 *
 * Subscribes to cartErrorStore and renders the appropriate dialog:
 * - GENERAL_ERROR: payment init failed, approve-order 422 (non-address), or signup error
 * - PAYPAL_INVALID_SHIPPING_ADDRESS: approve-order 422 with PAYPAL_INVALID_ADDRESS code
 *
 * Rendered outside the Suspense boundary in CartOverviewStep so dialogs are
 * available immediately — independent of cart data loading state.
 */
export function CartAlertDialogs({ constants, links }: CartAlertDialogsProps) {
  const { error, setError } = useCartErrorStore();

  if (!constants) {
    return null;
  }

  const handleClose = () => setError(null);

  return (
    <>
      <CartDialogAlertGeneral
        show={error === CART_DIALOG_TYPE.GENERAL_ERROR}
        onClose={handleClose}
        constants={constants}
        links={links}
      />

      <CartDialogAlertShippingAddress
        show={error === CART_DIALOG_TYPE.PAYPAL_INVALID_SHIPPING_ADDRESS}
        onClose={handleClose}
        constants={constants}
        links={links}
      />
    </>
  );
}
